import React, { useState } from "react";
import BaseTailoringQuestions from "../../shared/BaseTailoringQuestions";
import type { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface LitigationsClaimsTailoringQuestionsProps {
  onBack?: () => void;
  areaName?: string; // Optional areaName prop - defaults to "LIT" for Concluding Procedures
}

// Create the new questions for Litigations & Claims
function createQuestions(): TailoringQuestion[] {
  const questions: TailoringQuestion[] = [];

  // LIT-01: Document procedures performed
  questions.push({
    id: "LIT-01",
    question: "Document procedures performed in order to identify litigation and claims involving the entity which may give rise to a risk of material misstatement, including:\n\ni. Inquiry of management and, where applicable, others within the entity, including in-house legal counsel;\n\nii. Reviewing minutes of meetings of those charged with governance and correspondence between the entity and its external legal counsel; and\n\niii. Reviewing legal expense accounts.",
    type: "text", // Text type will automatically show DocumentManager
  });

  // LIT-02: Entity has in-house/external legal counsel
  questions.push({
    id: "LIT-02",
    question: "Does the entity have in-house legal counsel or external legal counsel who has the responsibility for the entity's litigations, claims and assessments?",
    type: "radio",
    options: ["In-house counsel", "External Counsel", "Both", "Not Applicable"],
    follow_up: {
      id: "LIT-02-doc",
      question: "Document your response",
      type: "text",
      condition: "always", // Always show the document manager regardless of selection
    },
  });

  return questions;
}

export default function LitigationsClaimsTailoringQuestions({ onBack, areaName }: LitigationsClaimsTailoringQuestionsProps) {
  // Determine areaName: use prop if provided, otherwise default to "LIT" for Concluding Procedures
  // This ensures Concluding Procedures saves to ConcludingProcedures_TailoringQuestions_Responses.json
  const finalAreaName = areaName || "LIT";

  // Create the questions directly
  const questions = createQuestions();

  return (
    <BaseTailoringQuestions
      areaName={finalAreaName}
      title="Litigations & Claims - Tailoring Questions"
      description="Answer the following questions based on litigations and claims requirements."
      questions={questions}
      onBack={onBack}
      onComplete={(answers) => {
        console.log("Litigations & Claims answers:", answers);
      }}
    />
  );
}
